export default {
    normal: "normal",
    simple: "simple"
}